// extracted by mini-css-extract-plugin
export default {"side_menu":"SameNewsSideBar_side_menu__4S8q2","title":"SameNewsSideBar_title__Jz1wZ","subject":"SameNewsSideBar_subject__COprD","divider":"SameNewsSideBar_divider__lBDJt"};